/** Statuses exposed in the staff venue-status filter (subset of GraphQL `RestaurantStatus`). */
export const RESTAURANT_STATUS_ORDER = [
  "PENDING",
  "PENDING_APPROVAL",
  "READY_TO_GO_LIVE",
  "LIVE",
  "ON_HOLD",
  "BLOCKED_OUT",
] as const;

export type RestaurantStatus = (typeof RESTAURANT_STATUS_ORDER)[number];

export const restaurantStatusLabels: { [K in RestaurantStatus]: string } = {
  PENDING: "Pending",
  PENDING_APPROVAL: "Pending approval",
  READY_TO_GO_LIVE: "Ready to go live",
  LIVE: "Live",
  ON_HOLD: "On hold",
  BLOCKED_OUT: "Blocked out",
};
